import { render } from "./IPConfirm.vue?vue&type=template&id=4b15df5c"
import script from "./IPConfirm.vue?vue&type=script&lang=js"
export * from "./IPConfirm.vue?vue&type=script&lang=js"

import "./IPConfirm.vue?vue&type=style&index=0&id=4b15df5c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__